import React from 'react';

import { Tabs } from '@mantine/core';
import { TabPanelWrapper } from 'components/TabPanelWrapper';
import { useManageSmartAssistantTabs } from 'hooks/use-manage-smart-assistant-tabs';
import { useManageSmartAssistantTabsConfiguration } from 'hooks/use-manage-smart-assistant-tabs-configuration';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';

interface ManageSmartAssistantTabRouterProps {
  smartAssistant: SmartAssistant;
  smartAssistantAvatar: React.ReactElement;
}

export function ManageSmartAssistantTabRouter({
  smartAssistant,
  smartAssistantAvatar
}: ManageSmartAssistantTabRouterProps) {
  const { allAvailableTabs, currentTab, handleTabChange } = useManageSmartAssistantTabs({
    smartAssistant
  });

  const tabsConfiguration = useManageSmartAssistantTabsConfiguration({
    smartAssistant,
    smartAssistantAvatar
  });

  // Redirect to the first tab if no tab is provided in the URL
  if (!currentTab && allAvailableTabs.length > 0) {
    return <Navigate to={`${ROUTE_LINKS.manageSmartAssistant}/${smartAssistant._id}/${allAvailableTabs[0]}`} replace />;
  }

  const manageTabs = allAvailableTabs.map((tab) => tabsConfiguration[tab]);

  return (
    <Tabs value={currentTab} inverted onTabChange={handleTabChange}>
      <Tabs.List>
        {manageTabs.map((tab, index: number) => {
          return (
            <Tabs.Tab value={tab.slug} icon={tab.icon} key={index} onClick={() => handleTabChange(tab.slug)}>
              {tab.label}
            </Tabs.Tab>
          );
        })}
      </Tabs.List>

      <Routes>
        <Route index element={<Navigate to={allAvailableTabs[0]} replace />} />

        {manageTabs.map((tab, index: number) => (
          <Route key={index} path={tab.slug + '/*'} element={<TabPanelWrapper>{tab.component}</TabPanelWrapper>} />
        ))}
      </Routes>
    </Tabs>
  );
}
